export const renderTextArea = (text: string = "") => {
  const lines = text ? text?.split('\n') : [];
  return lines.map((line: string, index: number) => (
    <p className="spaces m-0" key={index}>{line}</p>
  ))
}